import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

const LABELS = {
  users_total: 'Users', business_owners: 'Owners', employees: 'Employees', customers: 'Customers',
  businesses_total: 'Businesses', businesses_pending: 'Pending approvals', businesses_approved: 'Approved',
  premium_listings: 'Premium', enquiries_total: 'Enquiries', enquiries_new: 'New enquiries',
  ads_active: 'Active ads', categories: 'Categories', cities: 'Cities',
};

export default function AdminOverview() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => { api.get('/admin/stats').then(r => setD(r.data)).catch(e => setErr(e?.response?.data?.error || 'Failed to load stats')); }, []);
  if (err) return <div className="alert alert-danger" data-testid="admin-overview-error">{err}</div>;
  if (!d) return <div><span className="ap-loader" /></div>;

  return (
    <div data-testid="admin-overview">
      <h2 className="mb-3">Overview</h2>
      <div className="row g-3">
        {Object.entries(d.stats).map(([k,v]) => (
          <div className="col-6 col-md-3" key={k}>
            <div className="stat-card" data-testid={`stat-${k}`}>
              <div className="stat-label">{LABELS[k] || k}</div>
              <div className="stat-value">{v}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-3 mt-1">
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Top categories</h4>
            <ul className="list-unstyled">
              {d.top_categories.map((c,i) => (
                <li key={i} className="d-flex justify-content-between border-bottom py-2">
                  <span>{c.name}</span><strong>{c.c_count}</strong>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Recent businesses (7d)</h4>
            <ul className="list-unstyled">
              {d.business_trend.length === 0 ? <li className="text-muted-2 small">No recent data</li> :
                d.business_trend.map((t,i) => (
                  <li key={i} className="d-flex justify-content-between border-bottom py-2"><span>{t.d}</span><strong>{t.c}</strong></li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
